import React from "react";
const Text = () => {

    return (
        <div id="text">
            <h3>Text</h3>

            <p>
                Text blocks are used to create and manipulate strings—lines of text used in your app. These blocks help you build messages, process user input, and format data.
            </p>

            <div className="imageContainer">
                <img src="/images/text.png" alt="Text Blocks Overview" />
            </div>

            <ul>
                <li><strong>Create text with</strong> – Use this block to build a new string by combining multiple pieces of text.</li>
                <br />
                <li><strong>Convert to text</strong> – Converts a value (like a number or boolean) into a string. </li>
                <br />
                <li><strong>Append text to variable</strong> – Adds new text to the end of an existing variable.</li>
                <br />
                <li><strong>Length of text</strong> – Returns the number of characters in a string (including spaces).</li>
                <br />
                <li><strong>Display message</strong> – Shows a message on the screen.</li>
                <br />
                <li><strong>Show prompt with message</strong> – Displays a prompt asking the user for input.</li>
                <br />
                <li><strong>Is empty</strong> – Checks if a string or variable has no content.</li>
                <br />
                <li><strong>If confirm with message ... else</strong> – Displays a confirmation message to the user and runs different nested blocks based on whether the confirmation was accepted.</li>
                <br />
                <li><strong>Test value against regular expression</strong> – Checks if a string matches a specific pattern using regex.</li>
                <br />
                <li><strong>Find first occurrence of text</strong> – Finds where a substring first appears in a larger string.</li>
                <br />
                <li><strong>Get letter #</strong> – Retrieves a specific character from a string based on its position.</li>
                <br />
                <li><strong>Get substring from letter # to letter #</strong> – Extracts the portion of a string between two indices (inclusive), with the first character having index 1. </li>
                <br />
                <li><strong>To UPPER CASE</strong> – Converts all letters in a string to uppercase.</li>
                <br />
                <li><strong>Trim spaces</strong> – Removes whitespace from the beginning and end of a string.</li>
            </ul>

        </div>

    );

}
export default Text; 
